import type { ErrorEvent } from '@sentry/angular';

const EMAIL_PATTERN = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
const REDACTED = '[redacted]';

function redact(value: string | undefined): string | undefined {
  return value?.replace(EMAIL_PATTERN, REDACTED);
}

export function scrubSentryEvent(event: ErrorEvent): ErrorEvent {
  delete event.user;
  if (event.message) {
    event.message = redact(event.message);
  }
  for (const value of event.exception?.values ?? []) {
    if (value.value) {
      value.value = redact(value.value);
    }
  }
  for (const breadcrumb of event.breadcrumbs ?? []) {
    if (breadcrumb.message) {
      breadcrumb.message = redact(breadcrumb.message);
    }
  }
  if (event.request) {
    if (event.request.url) {
      event.request.url = redact(event.request.url);
    }
    if (event.request.headers) {
      for (const header of Object.keys(event.request.headers)) {
        const lower = header.toLowerCase();
        if (lower === 'cookie' || lower === 'authorization') {
          delete event.request.headers[header];
        }
      }
    }
  }
  return event;
}
